import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { AuthLayout } from '@/components/layout/auth-layout';
import { Button } from '@/components/ui/button';
import { authApi } from '@/api/auth';
import { apiErrorMessage } from '@/lib/api-error';

export function LegalConsentGate() {
  const [terms, setTerms] = useState(false);
  const [personalData, setPersonalData] = useState(false);
  const queryClient = useQueryClient();
  const consent = useMutation({
    mutationFn: authApi.updateLegalConsents,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['me'] }),
  });

  const accept = async () => {
    try {
      await consent.mutateAsync();
    } catch (error) {
      toast.error(apiErrorMessage(error, 'Не удалось сохранить согласие'));
    }
  };

  return (
    <AuthLayout
      title="Обновлённые условия"
      subtitle="Чтобы продолжить, подтверди актуальные документы Aniphys."
    >
      <div className="space-y-4">
        <ConsentRow checked={terms} onChange={setTerms}>
          Принимаю{' '}
          <Link className="underline" target="_blank" rel="noopener noreferrer" to="/legal/offer">
            договор-оферту
          </Link>
          {' '}и{' '}
          <Link className="underline" target="_blank" rel="noopener noreferrer" to="/legal/terms">
            пользовательское соглашение
          </Link>.
        </ConsentRow>
        <ConsentRow checked={personalData} onChange={setPersonalData}>
          Даю согласие на{' '}
          <Link className="underline" target="_blank" rel="noopener noreferrer" to="/legal/consent">
            обработку персональных данных
          </Link>
          , включая данные о здоровье, по{' '}
          <Link className="underline" target="_blank" rel="noopener noreferrer" to="/legal/privacy">
            политике конфиденциальности
          </Link>.
        </ConsentRow>
        <Button
          type="button"
          size="lg"
          className="w-full"
          disabled={!terms || !personalData || consent.isPending}
          onClick={accept}
        >
          Принять и продолжить
        </Button>
      </div>
    </AuthLayout>
  );
}

function ConsentRow({
  checked,
  onChange,
  children,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
}) {
  return (
    <label className="flex cursor-pointer items-start gap-2.5 text-xs leading-relaxed text-[var(--text-muted)]">
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 accent-[var(--accent)]"
      />
      <span>{children}</span>
    </label>
  );
}
